export const GREEN = 'green';
export const YELLOW = 'yellow';
export const RED = 'red';
